module.exports = __webpack_public_path__ + "static/media/zeroxense-IAS-logo.4e21ddd0.svg";